import { Injectable } from "@angular/core";
import { LoggerService } from "@teammood/shared/util/logger";
import { IUser } from '@teammood/shared/util/user';
import { CookieService } from "ngx-cookie-service";
import { Router } from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class RedirectPathService {

    private REDIRECT_KEY = "redirect";

    constructor(
        private logger: LoggerService,
        private cookieService: CookieService,
        private router: Router,
        ) { }

    store(redirect: string) {

        const storedPath = this.cookieService.get(this.REDIRECT_KEY);

        if (storedPath === '') {
            this.cookieService.set(this.REDIRECT_KEY, redirect);
            this.logger.info("Stored redirect " + redirect);
        }
    }

    private retrieve() {
        const redirectKey = this.cookieService.get(this.REDIRECT_KEY);

        if (redirectKey) {
            this.resetCookie();
            return redirectKey;
        }
    }

    resetCookie() {
        this.cookieService.delete(this.REDIRECT_KEY);
    }

    async redirectOnLogin(user: IUser) {

        const redirectFromCookie = this.retrieve();

        if (!redirectFromCookie) {
            if (user && user.home?.view) {
                this.logger.info('Authenticated. redirecting to home page.');
                await this.router.navigate([user.home?.view]);
            }
        } else {
            this.logger.info("Authenticated. Redirecting to " + redirectFromCookie);
            await this.router.navigateByUrl(redirectFromCookie);
        }
    }
}